import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsSchemasRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-assets',
	path: '/jira/servicedesk/assets',
	exact: true,
};
